import {
  useGetBatchDetail,
  useGetManagementBatchDetail,
} from "../../../hooks/queries/useBulkUploadsQueries";

export const useBatchDetail = (id, isSuperAdmin = false) => {
  const merchantQuery = useGetBatchDetail(id, { enabled: !isSuperAdmin });
  const managementQuery = useGetManagementBatchDetail(id, { enabled: isSuperAdmin });

  const { data, isLoading, isError, refetch } = isSuperAdmin ? managementQuery : merchantQuery;

  return {
    batchId: data?.batchId ?? null,
    submittedBy: data?.submittedBy ?? null,
    submittedOn: data?.submittedOn ?? null,
    status: data?.status ?? null,
    paymentChannel: data?.paymentChannel ?? null,
    recipientCount: data?.recipientCount ?? null,
    totalTransactions: data?.totalTransactions ?? null,
    successCount: data?.successCount ?? null,
    pendingCount: data?.pendingCount ?? null,
    failedCount: data?.failedCount ?? null,
    amount: data?.amount ?? null,
    charges: data?.charges ?? null,
    totalAmount: data?.totalAmount ?? null,
    merchantName: data?.merchant?.merchantName ?? null,
    isLoading,
    isError,
    refetch,
  };
};

export default useBatchDetail;
